import {
  ORGANISATION_CARD_PURPOSES,
  type OrganisationCardPurpose,
  type OrganisationPaymentCard,
} from '@dreamai/types';

export { ORGANISATION_CARD_PURPOSES };
export type { OrganisationCardPurpose, OrganisationPaymentCard };

export type CardAssignments = Record<OrganisationCardPurpose, string | null>;

export const CARD_PURPOSE_LABELS: Record<
  OrganisationCardPurpose,
  { title: string; description: string }
> = {
  subscription: {
    title: 'Monthly subscription',
    description: 'The monthly bill for everyone’s plan.',
  },
  topUps: {
    title: 'Buying extra credits',
    description: 'One-off credit purchases by an admin.',
  },
  memberSpending: {
    title: 'Member purchases',
    description: 'Purchases members make that the organisation pays for.',
  },
};

const BRAND_LABELS: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'Amex',
  'american express': 'Amex',
  discover: 'Discover',
  jcb: 'JCB',
  'diners club international': 'Diners Club',
  'union pay': 'UnionPay',
  unionpay: 'UnionPay',
};

export function cardBrandLabel(card: OrganisationPaymentCard): string {
  return card.brand
    ? (BRAND_LABELS[card.brand.toLowerCase()] ?? card.brand)
    : 'Card';
}

export function cardLabel(card: OrganisationPaymentCard): string {
  const brand = cardBrandLabel(card);
  return card.last4 ? `${brand} ending ${card.last4}` : brand;
}

/** The one card every purpose is on, or null when purposes differ. */
export function sharedCardId(assignments: CardAssignments): string | null {
  const ids = ORGANISATION_CARD_PURPOSES.map((p) => assignments[p]);
  return ids[0] && ids.every((id) => id === ids[0]) ? ids[0] : null;
}

const BRAND_ICONS: Record<string, string> = {
  visa: '/card-icons/visa.svg',
  mastercard: '/card-icons/mastercard.svg',
  'american express': '/card-icons/amex.svg',
  amex: '/card-icons/amex.svg',
  maestro: '/card-icons/maestro.svg',
  jcb: '/card-icons/jcb.svg',
  discover: '/card-icons/discover.svg',
};

export function cardBrandIcon(card: OrganisationPaymentCard): string {
  return (
    (card.brand && BRAND_ICONS[card.brand.toLowerCase()]) ??
    '/card-icons/generic.svg'
  );
}

/** "Visa •••• 1701" */
export function cardShortLabel(card: OrganisationPaymentCard): string {
  const brand = card.brand
    ? (BRAND_LABELS[card.brand.toLowerCase()] ?? card.brand)
    : 'Card';
  return card.last4 ? `${brand} •••• ${card.last4}` : brand;
}
